import router from '@/router';
import { isHttp } from '@/utils/validate';
import store from './store';
import { Message } from 'element-ui';

const VUE_APP_LOCALSTORAGE_TOKEN_NAME = process.env.VUE_APP_LOCALSTORAGE_TOKEN_NAME;

const whiteList = ['/login'];

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem(VUE_APP_LOCALSTORAGE_TOKEN_NAME)) {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      if (store.state.login.roles.length === 0) {
        const result = await store.dispatch('login/getInfo');
        if (result?.err) {
          await store.dispatch('login/logout');
          Message.error(result.err);
          next({ path: '/' });
        }
        else{
          const accessRoutes = await store.dispatch('permission/generateRoutes');
          if(accessRoutes?.length>0){
            // 根据roles权限生成可访问的路由表
            let routerList = [];
            accessRoutes.forEach((route) => {
                if (!isHttp(route.path)) {
                    routerList.push(route);
                }
            });
            router.addRoutes(routerList); // 动态添加可访问路由表
            // @ts-ignore
            next({ path: to.path, replace: true, params: to.params, query: to.query, hash: to.hash, name: to.name }); // hack方法 确保addRoutes已完成
          }
          else{
            next();
          }
        }
      }
      else if (!store.state.permission.routesGenerated) {
        const accessRoutes = await store.dispatch('permission/generateRoutes');
        if(accessRoutes?.length>0){
          // 根据roles权限生成可访问的路由表
          let routerList = [];
          accessRoutes.forEach((route) => {
              if (!isHttp(route.path)) {
                  routerList.push(route);
              }
          });
          router.addRoutes(routerList); // 动态添加可访问路由表
          // @ts-ignore
          next({ path: to.path, replace: true, params: to.params, query: to.query, hash: to.hash, name: to.name }); // hack方法 确保addRoutes已完成
        }
        else{
          next();
        }
      }
      else {
        next();
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      const redirect = encodeURIComponent(to.fullPath || '/');
      next(`/login?redirect=${redirect}`); // 否则全部重定向到登录页
    }
  }
});
